import {
  convocatoria001,
  n1,
  n2,
  n3,
  n4,
  n5,
  convocatoria002,
  n6,
  n7,
} from "../../json/anioLicitaciones/2026/anioLicitacion2026";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CONVOCATORIA 01-2026":
      datosSeleccionados = convocatoria001;
      break;
    case "EA-913005999-N1-2026":
      datosSeleccionados = n1;
      break;
    case "EA-913005999-N2-2026":
      datosSeleccionados = n2;
      break;
    case "EA-913005999-N3-2026":
      datosSeleccionados = n3;
      break;
    case "EA-913005999-N4-2026":
      datosSeleccionados = n4;
      break;
    case "EA-913005999-N5-2026":
      datosSeleccionados = n5;
      break;
    case "CONVOCATORIA 02-2026":
      datosSeleccionados = convocatoria002;
      break;
    case "EA-913005999-N6-2026":
      datosSeleccionados = n6;
      break;
    case "EA-913005999-N7-2026":
      datosSeleccionados = n7;
      break;

    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
